export default __webpack_public_path__ + "static/media/NO_Loose_Clothing.2249d3bd.jpg";